import { render, staticRenderFns } from "./CollectInput.vue?vue&type=template&id=73b81ea0"
import script from "./CollectInput.vue?vue&type=script&lang=js"
export * from "./CollectInput.vue?vue&type=script&lang=js"
import style0 from "./CollectInput.vue?vue&type=style&index=0&id=73b81ea0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports